// extracted by mini-css-extract-plugin
module.exports = {"salesBlock":"_2S2Y0Rer","rowInputs":"_3jK_hZFe","columnInputs":"_1n9yeO2y","inputsContainer":"BNaQHpPh","companyContainer":"_3SfHS9-c","companyLogo":"_3xVSl-RP","companyDetails":"_1rAHhXQ9","companyName":"_2jd_jK07","companyPosition":"_1Mes4YoL","companyYears":"_30V-nM-1","salesPeriodContainer":"_2Zck0CH4","salesPeriodTitle":"_3_VKQFC0","salesPeriodMonths":"_3OTe7NCu"};
    if(module.hot) {
      // 1746735792917
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  